"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSizeme = require("react-sizeme");

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _DropZone = _interopRequireDefault(require("../../DropZone"));

var _AssetListCard = _interopRequireDefault(require("./AssetListCard"));

var _AssetListItem = _interopRequireDefault(require("./AssetListItem"));

var _mediaSizes = _interopRequireDefault(require("../../../../../common/constants/mediaSizes"));

var _confirmActions = _interopRequireDefault(require("../../ConfirmationModal/constants/confirmActions"));

require("../styles/_assets-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var IN_PROGRESS = 'IN_PROGRESS';
var SEARCH_FILTER = {
  filterType: 'SEARCH',
  defaultValue: ''
};
var LIST_FILTERS = {
  ARCHIVED_FILTER: [{
    label: 'Active',
    value: 'ACTIVE'
  }, {
    label: 'Archived',
    value: 'ARCHIVED'
  }]
};

var AssetList = /*#__PURE__*/function (_Component) {
  _inherits(AssetList, _Component);

  function AssetList(props) {
    var _this;

    _classCallCheck(this, AssetList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssetList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "showManageAssetModal", (0, _lodash.default)(function (asset) {
      return function () {
        var showModal = _this.props.showModal;
        showModal(asset);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "showConfirmationModalHandler", (0, _lodash.default)(function (_ref) {
      var asset = _ref.asset,
          confirmModalAction = _ref.confirmModalAction;
      return function () {
        var showConfirmationModal = _this.props.showConfirmationModal;
        return showConfirmationModal({
          assetId: asset.assetId,
          confirmModalAction: confirmModalAction
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getOptions", (0, _lodash.default)(function (asset) {
      var _this$props = _this.props,
          archivedFilter = _this$props.archivedFilter,
          orgPermissions = _this$props.orgPermissions;
      var canDeleteAsset = (0, _lodash2.default)(asset, 'assetFiles.ORIGINAL.status', IN_PROGRESS) !== IN_PROGRESS && (0, _commonReact.hasPermission)('DELETE_ASSET', orgPermissions);
      var hasArchivePermission = (0, _commonReact.hasPermission)('ARCHIVE', asset.permissions);
      return [].concat(_toConsumableArray(hasArchivePermission && archivedFilter === 'ARCHIVED' ? [{
        action: _this.showConfirmationModalHandler({
          asset: asset,
          confirmModalAction: _confirmActions.default.UNARCHIVE
        }),
        label: 'Unarchive'
      }] : []), _toConsumableArray(hasArchivePermission && archivedFilter !== 'ARCHIVED' ? [{
        action: _this.showConfirmationModalHandler({
          asset: asset,
          confirmModalAction: _confirmActions.default.ARCHIVE
        }),
        label: 'Archive'
      }] : []), _toConsumableArray(canDeleteAsset ? [{
        action: _this.handleDeleteAsset({
          asset: asset
        }),
        label: 'Delete',
        isRed: true
      }] : []));
    }));

    _defineProperty(_assertThisInitialized(_this), "handleDeleteAsset", function (_ref2) {
      var asset = _ref2.asset;
      return function () {
        _this.setState({
          assetId: asset.assetId,
          assetTitle: asset.title || 'Asset',
          showDeleteConfirmation: true,
          hasAssetRelation: asset.assetRelations.length > 0
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "hideModal", function () {
      _this.setState({
        showDeleteConfirmation: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onComplete", function () {
      var onDeleteComplete = _this.props.onDeleteComplete;
      var _this$state = _this.state,
          assetId = _this$state.assetId,
          assetTitle = _this$state.assetTitle;

      _this.setState({
        showDeleteConfirmation: false
      }, function () {
        (0, _commonReact.notify)({
          content: "".concat(assetTitle, " successfully deleted"),
          type: 'success'
        });
        onDeleteComplete(assetId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCardItem", function (asset) {
      return _react.default.createElement(_AssetListCard.default, {
        item: asset,
        handleClick: _this.showManageAssetModal(asset),
        options: _this.getOptions(asset)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (asset) {
      return _react.default.createElement(_AssetListItem.default, {
        item: asset,
        handleClick: _this.showManageAssetModal(asset),
        options: _this.getOptions(asset)
      });
    });

    _this.state = {
      showDeleteConfirmation: false,
      hasAssetRelation: false,
      assetTitle: ''
    };
    return _this;
  }

  _createClass(AssetList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          setFilePickerRef = _this$props2.setFilePickerRef,
          history = _this$props2.history,
          loading = _this$props2.loading,
          assets = _this$props2.assets,
          dropZoneDisplayed = _this$props2.dropZoneDisplayed,
          handleFilterChange = _this$props2.handleFilterChange,
          closeDropZone = _this$props2.closeDropZone,
          deleteAsset = _this$props2.deleteAsset,
          loadMoreResults = _this$props2.loadMoreResults,
          totalResults = _this$props2.totalResults,
          getListRef = _this$props2.getListRef;
      var _this$state2 = this.state,
          showDeleteConfirmation = _this$state2.showDeleteConfirmation,
          assetId = _this$state2.assetId,
          hasAssetRelation = _this$state2.hasAssetRelation;
      var dropzoneVisible = !loading && (!assets || !assets.length || dropZoneDisplayed);
      return _react.default.createElement(_reactSizeme.SizeMe, null, function (_ref3) {
        var size = _ref3.size;
        return _react.default.createElement("div", {
          className: (0, _classnames.default)('library-asset-list', 'column', {
            'library-asset-list--hide-assets': dropzoneVisible,
            'library-asset-list--small': size.width < _mediaSizes.default.small
          })
        }, _react.default.createElement(_uiKit.List, {
          loading: loading,
          history: history,
          renderCardItem: _this2.renderCardItem,
          renderListItem: _this2.renderListItem,
          emptyDataText: " ",
          data: assets,
          filters: LIST_FILTERS,
          onFiltersChange: handleFilterChange,
          options: [],
          searchFilter: SEARCH_FILTER,
          listKey: "assetId",
          loadMoreResults: loadMoreResults,
          totalResults: totalResults,
          getInfiniteScrollParent: getListRef
        }, _react.default.createElement(_DropZone.default, {
          setFilePickerRef: setFilePickerRef,
          closeDropZone: closeDropZone,
          isVisible: dropzoneVisible,
          handleDragOut: closeDropZone
        })), showDeleteConfirmation && _react.default.createElement(_commonReact.DeleteConfirmationModal, {
          onDelete: deleteAsset,
          objectId: assetId,
          hideModal: _this2.hideModal,
          onComplete: _this2.onComplete,
          title: "Delete Asset",
          subTitle: "Are you sure you want to delete this asset?",
          warnings: hasAssetRelation ? ['All asset references will be removed'] : void 0
        }));
      });
    }
  }]);

  return AssetList;
}(_react.Component);

exports.default = AssetList;